import InfoIcon from "@material-ui/icons/Info";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import { IRoute } from "src/common/typings/routes";
import { Listing } from "./pages/reports/index";
import { Listing as containerReports } from "./pages/container-reports/index";
import { Report } from "./Report";
import { GenericReport } from "./pages/generic-vehicle-report/index";
import { GenericReport as ContainerGenericReport } from "./pages/generic-container-report/index";
import { ExaminationReport as ContainerExamReport } from "./pages/Examination/index";
import { StuffDestuffReport } from "./pages/StuffDestuffReport/index";

export const ReportsRoute: IRoute = {
  title: "Reports",
  path: "/reports",
  icon: InsertDriveFileIcon,
  component: Report,
  guard: true,
  subRoutes: [
    { icon: InfoIcon, component: Listing, path: "/vehicle-reports", title: "Vehicle Reports" },
    {
      icon: InfoIcon,
      component: GenericReport,
      path: "/generic-Vehicle-report",
      title: "Generic Vehicle Report",
    },
    {
      icon: InfoIcon,
      component: ContainerGenericReport,
      path: "/generic-container-report",
      title: "Generic Container Report",
    },
    {
      icon: InfoIcon,
      component: containerReports,
      path: "/container-reports",
      title: "Container Reports",
    },
    {
      icon: InfoIcon,
      component: StuffDestuffReport,
      path: "/stuff-destuff-report",
      title: "Stuff/Destuff Report",
    },
    {
      icon: InfoIcon,
      component: ContainerExamReport,
      path: "/examination-report",
      title: "Examination Report",
    },
  ],
};
